import { isFeatureFlagEnabledHTML } from 'www/utils'

const svgIcon = `
            <svg class="b-select__trigger-icon-svg b-icon b-icon-chevron-down" width="16" height="16">
                <use xlink:href="/static/_v1/pd/svg-sprites/global.svg#icon-chevron-down"></use>
            </svg>
    `

const fontIcon = '<div class="b-select__trigger-icon-svg ui-icon-arrow-down ui-icon-fz-medium"></div>'

function createOption(val, text, aditText, disabled, attributes) {
  const $option = $(`
            <li>
                <div class="b-select__option-text">
                    <span class="b-select__option-main-text"></span>
                </div>
            </li>
        `)

  $option.attr('data-value', val)
  $option.attr('data-placeholder', text)
  $option.attr('data-adit-text', aditText)

  Array.prototype.slice.call(attributes).forEach(attr => {
    $option.attr(attr.name, attr.value)
  })

  $option.addClass('b-select__option')

  if (disabled) {
    $option.addClass('b-select__option_is_disabled')
  }

  $option.find('.b-select__option-main-text').text(text)

  if (aditText) {
    const $subtext = $('<span class="b-select__option-adit-text"></span>').text(aditText)

    $option.find('.b-select__option-text').append($subtext)
  }

  return $option
}

function renderTriggerText(mainText, aditText) {
  const $triggerText = $(`
            <div class="b-select__trigger-text">
                <span class="b-select__trigger-main-text"></span>
            </div>
        `)

  $triggerText.find('.b-select__trigger-main-text').text(mainText)

  if (aditText && !isFeatureFlagEnabledHTML({ dataAttr: 'data-is-town-online' })) {
    $triggerText.append($('<span class="b-select__trigger-adit-text"></span>').text(aditText))
  }

  return $triggerText
}

function createBSelect() {
  // eslint-disable-next-line func-names
  $('.b-select').each(function () {
    const classList = $(this).attr('class').replace('b-select__source', '')
    const $optionArr = [...$(this).find('option')]
    const $options = $('<ul class="b-select__options"></ul>')
    const useFontIcon = this.classList.contains('b-select_font-icon')

    $optionArr.forEach(opt => {
      $options.append(createOption(
        $(opt).val(),
        $(opt).text(),
        $(opt).attr('data-adit-text'),
        $(this).val() === $(opt).attr('value'),
        $(opt).prop('attributes'),
      ))
    })

    let triggerIcon = 'text'
    let template = ''
    const $selectedOption = $(this).find('option:checked')

    if ($(this).attr('data-year')) {
      triggerIcon = 'year'
    }

    let mainText = $(this).attr('placeholder')
    let aditText = ''

    if ($selectedOption && $selectedOption.length) {
      if ($selectedOption.text()) {
        mainText = $selectedOption.text()
      }

      if ($selectedOption.attr('data-adit-text')) {
        aditText = $selectedOption.attr('data-adit-text')
      }
    } else if ($(this).attr('data-adit-text')) {
      aditText = $(this).attr('data-adit-text')
    }

    const $triggerText = renderTriggerText(mainText, aditText)

    if (triggerIcon === 'text') {
      template = `
                <div class="${classList} ${$optionArr.length < 2 ? 'b-select_is-empty' : ''}">
                    <span class="b-select__trigger ${$optionArr.length < 2 ? 'b-select__trigger_is-empty' : ''}">
                        <div class="b-select__trigger-icon">
                            ${useFontIcon ? fontIcon : svgIcon}
                        </div>
                    </span>
                </div>
            `
    } else {
      template = `
                <div class="${classList} ${$optionArr.length < 2 ? 'b-select_is-empty' : ''}">
                    <span class="b-select__trigger ${$optionArr.length < 2 ? 'b-select__trigger_is-empty' : ''}">
                        <div class="b-select__trigger-icon b-select__trigger-icon_time">
                            <svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.98038 0.9C3.21132 0.5 3.78868 0.5 4.01962 0.9L6.01147 4.35C6.24241 4.75 5.95374 5.25 5.49186 5.25H1.50814C1.04626 5.25 0.757586 4.75 0.988526 4.35L2.98038 0.9Z" fill="#C7D3D9"/>
                                <path d="M2.98038 12.1C3.21132 12.5 3.78868 12.5 4.01962 12.1L6.01147 8.65C6.24241 8.25 5.95374 7.75 5.49186 7.75H1.50814C1.04626 7.75 0.757586 8.25 0.988526 8.65L2.98038 12.1Z" fill="#C7D3D9"/>
                            </svg>
                        </div>
                    </span>
                </div>
            `
    }

    $(this).wrap('<div class="b-select-wrapper"></div>')

    const $selector = $(template)

    if ($optionArr.length > 1) {
      $selector.append($options)
    }

    $selector.find('.b-select__trigger').prepend($triggerText)

    $(this).after($selector)
  })

  // eslint-disable-next-line func-names
  $('.b-select:not(\'.b-select_is-empty\') .b-select__trigger').on('click', function (e) {
    const $select = $(this).parents('.b-select-wrapper').find('.b-select').first()

    if ($select.attr('disabled') === 'disabled') {
      return
    }

    const isOpened = $(this).parents('.b-select').hasClass('b-select_is_opened')

    $('.b-select').removeClass('b-select_is_opened')

    $('html').one('click', () => {
      $('.b-select').removeClass('b-select_is_opened')
    })

    if (!isOpened) {
      $(this).parents('.b-select').addClass('b-select_is_opened')
    }

    e.stopPropagation()
  })

  // eslint-disable-next-line no-use-before-define
  $('.b-select__option').on('click selected', handleOptionSelected)
}

function handleOptionSelected(eventNameTrigger) {
  if ($(this).attr('data-disable')) {
    return
  }

  try {
    const ageRange = $(this).attr('data-doctor-age-range')
    const hasSpeciality = Boolean($(this).attr('data-has-speciality'))

    if (ageRange && hasSpeciality) {
      $(this)
        .closest('.b-doctor-card')
        .find('[data-qa="doctor_workplace_age_limit_text"]')
        .text(ageRange)
    }
  } catch { /* Empty */ }

  const $select = $(this).closest('.b-select')
  const useFontIcon = $select.hasClass('b-select_font-icon')

  $(this).parents('.b-select-wrapper').find('option:checked').prop('selected', false)
  $(this).parents('.b-select-wrapper').find(`option[value='${$(this).attr('data-value')}']`).prop('selected', true)

  const $opt = $select.find('.b-select__option')

  $(this).parents('.b-select-wrapper').find('select').val($(this).attr('data-value'))
  $(this).parents('.b-select-wrapper').find('select').trigger({
    type: 'change',
    eventNameTrigger,
  })
  $(this).parents('.b-select-wrapper').find('select')[0].dispatchEvent(new Event('change'))

  $opt.removeClass('b-select__option_is_disabled')
  $(this).addClass('b-select__option_is_disabled')

  const selectType = $(this).parents('.b-select-wrapper').find('select').attr('data-year')

  if (selectType) {
    $select.find('.b-select__trigger').html(
      `
            <div class="b-select__trigger-text">
                <span class="b-select__trigger-main-text">${$(this).attr('data-placeholder')}</span>
                ${$(this).attr('data-adit-text') && !isFeatureFlagEnabledHTML({ dataAttr: 'data-is-town-online' }) ? `<span class="b-select__trigger-adit-text">${$(this).attr('data-adit-text')}</span>` : ''}
            </div>
            <div class="b-select__trigger-icon b-select__trigger-icon_time">
                <svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.98038 0.9C3.21132 0.5 3.78868 0.5 4.01962 0.9L6.01147 4.35C6.24241 4.75 5.95374 5.25 5.49186 5.25H1.50814C1.04626 5.25 0.757586 4.75 0.988526 4.35L2.98038 0.9Z" fill="#C7D3D9"/>
                    <path d="M2.98038 12.1C3.21132 12.5 3.78868 12.5 4.01962 12.1L6.01147 8.65C6.24241 8.25 5.95374 7.75 5.49186 7.75H1.50814C1.04626 7.75 0.757586 8.25 0.988526 8.65L2.98038 12.1Z" fill="#C7D3D9"/>
                </svg>
            </div>
            `,
    )
  } else {
    $select.find('.b-select__trigger-text').replaceWith(renderTriggerText($(this).attr('data-placeholder'), $(this).attr('data-adit-text')))
    $select.find('.b-select__trigger-icon').replaceWith($(`
                <div class="b-select__trigger-icon">
                    ${useFontIcon ? fontIcon : svgIcon}
                </div>
            `))
  }
}

createBSelect()

document.addEventListener('content-replace', () => {
  createBSelect()
}, false)

window.addEventListener('pageshow', () => {
  [...document.querySelectorAll('select.b-select')].forEach(bSelect => {
    if (bSelect.dataset.disableBrowserCache === 'true') {
      bSelect.querySelectorAll('option').forEach(option => {
        option.selected = option.defaultSelected
      })
    } else {
      const { selectedIndex } = bSelect
      const bSelectWrapper = bSelect.closest('.b-select-wrapper')
      const selectedOption = bSelectWrapper?.querySelector(`.b-select__option:nth-child(${selectedIndex + 1})`)

      if (selectedOption) {
        selectedOption.click()
      }
    }
  })
})
